import { useContext, useEffect, useRef, useState } from "react";
import LiveChat from "react-livechat";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { Link, useNavigate } from "react-router-dom";
import { log } from "../../commonfunctions/logger";
import { setLoginStatus } from "../../redux/actions/userSession";
import { RootState } from "../../redux/store";
import Dropdown from "../Dropdown/Dropdown";
import Button, { ButtonType } from "../Button/Button";
import IconButton from "../IconButton/IconButton";
import SearchBar from "../SearchBar/SearchBar";
import Sidebar from "../Sidebar/Sidebar";
import NotificationBar from "./NotificationBar";
import { Context, IContext } from "../../context/ContextApp";
import Icon from "../Icon/icon";
import FashionbizLogo from "../../assets/FashionbizLogo";

const Header = () => {
  const currentOrder = useSelector((state: RootState) => state.orders.currentOrder);
  const [sidebarCollapsed, setSidebarCollapsed] = useState<boolean>(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const livechat = useRef();
  const location = useLocation();
  const { appBranch }: IContext = useContext(Context);
  const isStockListMode = localStorage.getItem("stocklist_mode") === "true";
  const legacyBranch = appBranch.toUpperCase();

  useEffect(() => {
    if (self == top) {
      // Everything checks out, show the page.
      document.documentElement.style.display = "block";
    } else {
      // Break out of the frame.
      if (top != undefined) {
        top.location = window.location.href;
      }
    }
    if (sidebarCollapsed) {
      document.body.style.overflow = "";
    } else {
      document.body.style.overflow = "hidden";
    }
  }, [sidebarCollapsed]);

  useEffect(() => {
    setSidebarCollapsed(true);
  }, [location.search, location.pathname]);

  const logOff = () => {
    destroyLiveChat(livechat.current);
    dispatch(setLoginStatus(false));
    navigate("/");
    // To refresh livechat SPA
    window.location.reload();
  };

  const renderLiveChat = (liveChatBranch: string) => {
    if (
      process.env["REACT_APP_LIVECHAT_LICENSE_ID_" + liveChatBranch.toUpperCase()] &&
      process.env.NODE_ENV === "production"
    ) {
      return (
        <LiveChat
          license={process.env["REACT_APP_LIVECHAT_LICENSE_ID_" + liveChatBranch.toUpperCase()]}
          onChatLoaded={(ref: any) => {
            livechat.current = ref;
            ref.on_after_load = () => {
              ref.hide_chat_window;
            };
          }}
          visitor={{ email: localStorage.getItem("email") }}
        />
      );
    }
  };

  const destroyLiveChat = (lc: any) => {
    try {
      lc.close_chat();
      lc.hide_chat_window();
    } catch (error) {
      log(error, "Live chat destruction failed.");
    }
  };

  return (
    <>
      {appBranch !== "ca" && renderLiveChat(appBranch)}
      <header className="header">
        <NotificationBar />
        <nav>
          <div className="logo" onClick={() => navigate("/")}>
            <FashionbizLogo className="logo-svg" aria-label="Fashionbiz" />
            <span className="logo-branch">DISTRIBUTOR CENTRE {appBranch.toUpperCase()}</span>
          </div>

          <div className="actions">
            <a
              href={process.env[`REACT_APP_LEGACY_WEBSTORE_URL_${legacyBranch}`]}
              className="action action--legacy"
              target="_blank"
              rel="noreferrer"
            >
              Return to Previous Version
              <Icon name="ExternalLink" iconWidth="0.85rem" />
            </a>
            {!isStockListMode && (
              <div className="action action--cart">
                <Link to="/store/cart" className="action-link">
                  {currentOrder ? (
                    <>
                      <span className="cart-icon-wrapper">
                        <IconButton style={{ marginRight: "5px" }} inline>
                          <Icon name="ShoppingCartWhite" />
                        </IconButton>
                        {currentOrder.total_items > 0 && (
                          <span className="cart-badge">{currentOrder.total_items}</span>
                        )}
                      </span>
                      <span className="action-label">
                        {`${currentOrder.total_items} ${currentOrder.total_items === 1 ? "item" : "items"} / ${currentOrder.total_units} ${currentOrder.total_units === 1 ? "unit" : "units"}`}
                      </span>
                      <span className="action-label">{` -  $${parseFloat(currentOrder.payment_details.total_products).toFixed(2)}`}</span>
                    </>
                  ) : (
                    <span className="action-label">Loading...</span>
                  )}
                </Link>
              </div>
            )}
            <div className="action action--user">
              <Dropdown
                list={[
                  { title: "Quick order", link: "/quick-order", iconName: "Pencil" },
                  { title: "Saved orders", link: "/saved-orders", iconName: "Save" },
                  { title: "Order import", link: "/order-uploader", iconName: "FileUpload" },
                  { title: "Order history", link: "/order-history", iconName: "Clipboard" },
                  { title: "Transactions", link: "/transactions", iconName: "CreditCard" },
                  { title: "Preferences", link: "/preferences", iconName: "Cog" },
                  { title: "Log Out", iconName: "SignOutAlt", onAction: logOff },
                ]}
              >
                <>
                  <IconButton style={{ marginRight: "5px" }} inline>
                    <Icon name="CaretCircleDown" />
                  </IconButton>
                  <span className="action-label">
                    {localStorage.getItem("email") ?? "Not logged in"}
                  </span>
                </>
              </Dropdown>
            </div>
          </div>
        </nav>
        <div
          className="secondary-nav"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div className="secondary-nav__center">
            <Button
              type={ButtonType.secondary}
              onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
              className="menu-opener"
            >
              <Icon name="Bars" iconWidth="1.3rem" />
              <span>Menu</span>
            </Button>
            <SearchBar route="/search?q" page={1} searchQuery="Search by Style" />
          </div>
          {isStockListMode && (
            <span
              style={{
                color: "#043455",
                marginRight: "60px",
                padding: "5px",
                // border: "1px solid #043455",
              }}
            >
              Stocklist mode
            </span>
          )}
          {!isStockListMode && (
            <Link to="/store/cart" className="secondary-nav__cart">
              <IconButton inline>
                <Icon name="ShoppingCartBlack" iconWidth="1.3rem" />
              </IconButton>
              {currentOrder && currentOrder.total_items > 0 && (
                <span className="cart-badge cart-badge--dark">{currentOrder.total_items}</span>
              )}
            </Link>
          )}
        </div>
      </header>
      <Sidebar
        isSidebarCollapsed={sidebarCollapsed}
        collapseSidebar={() => setSidebarCollapsed(true)}
        email={localStorage.getItem("email") ?? ""}
        onLogOut={logOff}
      />
    </>
  );
};

export default Header;
